import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const ASSIGNMENT_QUEUE_BASE_PATH = `${MIDDLE_OFFICE_BASE_PATH}/assignment-queues`;
